import React from "react";

const SkeletonSections = ({ sections = 2 }) => (
	<div role="status" className="w-full p-4 animate-pulse md:p-6">
		<div className="flex items-baseline mt-4 flex-wrap gap-3 w-full">
			{Array.from({ length: sections }).map((_, index) => (
				<div
					key={index}
					className="w-full bg-gray-100 h-96 dark:bg-gray-200"
				/>
			))}

		</div>
		<span className="sr-only">Loading...</span>
	</div>
);
export default SkeletonSections;